import LocalStorage from "./LocalStorage";
import StorageDecoratorEncrypter from "./decorator/StorageDecoratorEncrypter";
import EncrypterFactory from "../Encrypter/factory";

export default class StorageFactory {
  public static simpleLocalStorage = () => {
    return new LocalStorage();
  };

  public static encrypterLocalStorage = () => {
    return new StorageDecoratorEncrypter(
      new LocalStorage(),
      EncrypterFactory.simpleCryptoEncrypter()
    );
  }
}
